import { useContext, useState } from 'react'
import { useMediaQuery } from 'usehooks-ts'

import { TextButton, TextInput } from 'slab'
import { postMarketplaceProductRequest } from 'utils/web_api'

import { SessionContext } from '../shared'
import { emitProductRequestSubmittedEvent } from '../shared/events'
import { Modal } from '../shared/Modal'

const mobilePlaceholder = 'e.g. BetterHelp, not "therapy"'
const desktopPlaceholder = 'Tip: Request specific brands (e.g. BetterHelp instead of "therapy")'

export function Footer () {
  const [isModalOpen, setIsModalOpen] = useState(false)
  const [requestInput, setRequestInput] = useState('')
  const isMobile = useMediaQuery('(max-width: 570px)')
  const member = useContext(SessionContext)

  if (member.publicView) {
    return null
  }

  const openModal = () => setIsModalOpen(true)
  const closeModal = () => {
    setIsModalOpen(false)
    setRequestInput('')
  }

  const handleSubmit = async () => {
    emitProductRequestSubmittedEvent(member, requestInput)
    await postMarketplaceProductRequest({ name: requestInput })
    closeModal()
  }

  return (
    <>
      <div className='flex flex-row flex-wrap justify-center gap-2 py-3 px-4 mt-8'>
        <p className='text-gray-600 whitespace-nowrap'>Looking for something else?</p>
        <TextButton color='purple' onClick={openModal}>
          <span className='whitespace-nowrap'>Request a new product or service</span>
        </TextButton>
      </div>

      <Modal
        isOpen={isModalOpen}
        onClose={closeModal}
        title='Which brand or service should we add next?'
        size='lg'
        primaryAction={{
          label: 'Submit request',
          handleOnClick: handleSubmit,
          disabled: !requestInput.trim(),
        }}
        secondaryAction={{
          label: 'Cancel',
          handleOnClick: closeModal,
        }}
      >
        <div className='flex flex-col gap-6'>
          <p className='body text-gray-600'>
            We're actively expanding our partnerships to bring you more high-impact health products and services
          </p>
          <TextInput
            placeholder={isMobile ? mobilePlaceholder : desktopPlaceholder}
            value={requestInput}
            onChange={(e) => setRequestInput(e.target.value)}
            width='full'
            autoFocus
          />
        </div>
      </Modal>
    </>
  )
}
